import { render, staticRenderFns } from "./BaseBSplitPanel.vue?vue&type=template&id=38a364d6"
import script from "./BaseBSplitPanel.vue?vue&type=script&lang=js"
export * from "./BaseBSplitPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseBSplitPanel.vue?vue&type=style&index=0&id=38a364d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports